/** Non-empty `size` after trim (handles `null` / absent). */
export function variantHasDisplayableSize(variant: {
  size?: string | null
}): boolean {
  return Boolean(variant.size?.trim())
}

/** Text on a variant chip: prefer size axis, otherwise name or code. */
export function getVariantChoiceLabel(variant: {
  size?: string | null
  name?: string
  code: string
}): string {
  const size = variant.size?.trim()
  if (size) return size
  const name = variant.name?.trim()
  if (name) return name
  return variant.code
}

export function productVariantsHaveAnyDisplayableSize<
  V extends { size?: string | null }
>(variants: V[] | undefined | null): boolean {
  return (variants ?? []).some(variantHasDisplayableSize)
}

/** Hide the lone empty size chip when there is a single variant with no size. */
export function shouldShowVariantSizeButtons<
  V extends { size?: string | null }
>(variants: V[] | undefined | null): boolean {
  const list = variants ?? []
  return list.length > 1 || productVariantsHaveAnyDisplayableSize(list)
}
